import { Branding } from "@bcm-dev/bcms-vite";
import { TableBody, TableView } from "components/shared";
import React from "react";
import EntitlementsAccountsProfilesTableHeader, { AccountsProfilesTableHeaderItemView } from "../EntitlementsAccountsProfilesTableHeader";
import { EntitlementsAccountsTableRow } from "../EntitlementsAccountsProfilesTableRow";

import "./styles.css";

/**
 * @function EntitlementsAccountsTable
 * @returns {React.Component}
 * @description The is the main Entitlements Acounts table for Entitlements Page.
 */
export default function EntitlementsAccountsTable(props) {
    const accounts = props.accounts ?? [];
    const rows = accounts.reduce((acc, item) => {
        const name = `${ item.number } - ${ item.name }`;
        acc.push(
            <EntitlementsAccountsTableRow key={ item.id } name={ name } account={ item } dataPoint="Account" />
        );
        return acc;
    }, []);

    return (
        <TableView className="entitlements-accounts-table">
            <EntitlementsAccountsProfilesTableHeader>
                <AccountsProfilesTableHeaderItemView dataPoint="Accounts" className="header-col accounts-col" text="Accounts" />
                <AccountsProfilesTableHeaderItemView className="skewed-col all-entitlements-col" text="All Entitlements" />
                <Branding id="stop_payments_abi22" value="true">
                    <AccountsProfilesTableHeaderItemView className="skewed-col stop-payments-col" text="Stop Payments" />
                </Branding>
                <AccountsProfilesTableHeaderItemView className="skewed-col view-col" text="View" />
                <Branding id="ach_abi22" value="true">
                    <AccountsProfilesTableHeaderItemView className="skewed-col ach-from-col" text="ACH From" />
                    <AccountsProfilesTableHeaderItemView className="skewed-col ach-to-col" text="ACH To" />
                </Branding>
                <AccountsProfilesTableHeaderItemView className="skewed-col transfer-from-col" text="Transfer From" />
                <AccountsProfilesTableHeaderItemView className="skewed-col transfer-to-col" text="Transfer To" />
                <Branding id="wires_abi22" value="true">
                    <AccountsProfilesTableHeaderItemView className="skewed-col wires-col" text="Wires" />
                </Branding>
            </EntitlementsAccountsProfilesTableHeader>

            <TableBody>{ rows }</TableBody>
        </TableView>
    );
}
